import { useNavigate } from 'react-router-dom'
import { RoutesEnum } from '../lib/routes'
import { useLang } from '../lib/useLang'

export default function Hero() {
  const navigate = useNavigate()
  const { t } = useLang()

  return (
    <section className='relative overflow-hidden hairline-bottom'>
      <div className='hero-grid hero-grid-strong' aria-hidden='true' />

      <div className='relative mx-auto max-w-6xl px-6 lg:px-10 pt-32 md:pt-44 pb-28 md:pb-40 text-center'>
        <h1 data-reveal className='headline-display text-5xl md:text-7xl lg:text-[5.4rem] max-w-5xl mx-auto'>
          {t('lp.hero.h1Part1')}
          <br />
          <span className='text-muted'>{t('lp.hero.h1For')}</span>
          <span className='accent-text'>{t('lp.hero.h1Highlight')}</span>
        </h1>

        <p data-reveal className='mt-8 text-lg md:text-xl text-muted max-w-2xl mx-auto leading-relaxed'>
          {t('lp.hero.sub')}
        </p>

        <div data-reveal className='mt-10 flex flex-wrap justify-center gap-3'>
          <button
            type='button'
            onClick={() => navigate(RoutesEnum.CONTACT)}
            className='btn-primary'
          >
            {t('lp.hero.btnPrimary')}
          </button>
          <button
            type='button'
            onClick={() => navigate(RoutesEnum.CONTACT)}
            className='btn-ghost'
          >
            {t('lp.hero.btnGhost')}
          </button>
        </div>
      </div>
    </section>
  )
}
